<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="shadow-lg">
          <div class="row content-add-btn">
            <button class="btn btn-secondary" @click="$router.go(-1)">
              <em class="fa fa-chevron-left"></em>
              {{ $t('common_words.exit') }}
            </button>
          </div>
          <hr />
          <form-wizard
            ref="formWizard"
            v-if="this.isCreate() || this.isUpdate()"
            @on-complete="storeUpdateUser"
            title
            subtitle
            :back-button-text="$t('common_words.back')"
            :next-button-text="$t('common_words.next')"
            :finish-button-text="$t('common_words.save')"
            class="custom-padding-wz-header"
          >
            <tab-content
              :title="$t('common_words.general_information')"
              :before-change="() => validateStep('firstStep')"
            >
              <first-step
                ref="firstStep"
                @on-validated="onStepValidated"
                @fillUserForm="fillUserForm"
                @showHideLoading="showHideLoading"
              ></first-step>
            </tab-content>
            <tab-content
              :title="$t('common_words.profile_and_permissions')"
              :before-change="() => validateStep('secondStep')"
            >
              <second-step
                ref="secondStep"
                @on-validated="onStepValidated"
                @fillUserForm="fillUserForm"
                @showHideLoading="showHideLoading"
              ></second-step>
            </tab-content>
            <tab-content :title="$t('common_words.confirm')">
              <p class="cm-mg-p-wzd text-center text-muted">
                3.1 {{ $t('common_words.verify_inputed_information') }}
              </p>
              <br />
              <div class="row d-flex justify-content-center">
                <div class="col-9">
                  <table class="table">
                    <tbody>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong> {{ $t('common_words.names') }}: </strong>
                          </h6>
                          {{ userForm.first_name }} {{ userForm.last_name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong> {{ $t('common_words.user') }}: </strong>
                          </h6>
                          {{ userForm.username }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong> {{ $t('common_words.email') }}: </strong>
                          </h6>
                          {{ userForm.email }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong> {{ $t('common_words.profile') }}: </strong>
                          </h6>
                          <el-tag type="info">{{ userForm.name_role }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>
                              {{ $t('common_words.associated_companies') }}:
                            </strong>
                          </h6>
                          <span
                            v-for="(
                              business, index
                            ) in userForm.names_businesses"
                            :key="index"
                          >
                            <el-tag type="info">{{ business }}</el-tag>
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>
                              {{ $t('common_words.associated_farms') }}:</strong
                            >
                          </h6>
                          <span
                            v-for="(farm, index) in userForm.names_farms"
                            :key="index"
                          >
                            <el-tag type="info">{{ farm }}</el-tag>
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>
                              {{
                                $t('common_words.associated_permissions')
                              }}:</strong
                            >
                          </h6>
                          <div class="row">
                            <div class="col-4">
                              <blockquote>
                                <h5>
                                  {{ $t('common_words.globals') }}
                                </h5>
                                <el-tree
                                  :data="userForm.selected_general_permissions"
                                  show-checkbox
                                  node-key="id"
                                  :default-checked-keys="
                                    userForm.general_permissions
                                  "
                                  default-expand-all
                                  :props="{
                                    children: 'children',
                                    label: 'label',
                                    disabled: 'disabled',
                                  }"
                                >
                                </el-tree>
                              </blockquote>
                            </div>
                            <div class="col-8">
                              <blockquote>
                                <h5>
                                  {{ $t('common_words.specifics') }}
                                </h5>
                                <el-tree
                                  :data="userForm.selected_specific_permissions"
                                  show-checkbox
                                  node-key="id"
                                  :default-checked-keys="
                                    userForm.specific_permissions
                                  "
                                  :props="{
                                    children: 'children',
                                    label: 'label',
                                    disabled: 'disabled',
                                  }"
                                >
                                </el-tree>
                              </blockquote>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </tab-content>
          </form-wizard>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_operations') }}
            </h5>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMasters from 'src/util/mixinMasters';
import { Tree } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
    [Tree.name]: Tree,
  },

  data() {
    return {
      title: '',
      userForm: {},
      wizardModel: {},
    };
  },

  mixins: [MixinPermissions, MixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        first_name: null,
        last_name: null,
        email: null,
        username: null,
        businesses: [],
        farms: [],
        only_filter_own_farms: false,
      };
      this.$refs.secondStep.model = {
        role_id: '',
        general_permissions: [],
        specific_permissions: [],
        selected_general_permissions: [],
        selected_specific_permissions: [],
      };
      this.$refs.secondStep.resetTree();
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillUserForm(ref, others) {
      this.userForm = Object.assign({}, this.userForm, this.$refs[ref].model);
      if (others) this.userForm = Object.assign({}, this.userForm, others);
    },

    storeUpdateUser() {
      this.showHideLoading(true);
      this.userForm.route = 'users';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.userForm.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.userForm)
            .then((response) => {
              this.showHideLoading();
              this.forceRenderMenu();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/users',
                'userForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.userForm)
            .then((response) => {
              this.showHideLoading();
              this.forceRenderMenu();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/users',
                'userForm'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('users');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('users');
  },
};
</script>
